<template>
  <div>
    <list-table
      :url="url"
      title="لیست تسویه ها"
      :detailUrl="detailUrl"
      :fields="fields"
      :params="params"
      :tabTable="tabTable"
    ></list-table>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import moment from "jalali-moment";
export default {
  name: "",
  data() {
    return {
      list: [],
      url: "/reports/api/v2/transfers",
      detailUrl: "core/transfers",
      fields: [
        {
          key: "gateway.website_name",
          label: "نام درگاه",
        },
        {
          key: "amount",
          label: "مبلغ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "destinationIban",
          label: "شماره شبا مقصد",
          formatter(value, key, item) {
            return value;
            // return Number(value).toLocaleString()
          },
        },
        {
          key: "destinationFirstName",
          label: "نام و نام خانوادگی مقصد",
          formatter(value, key, item) {
            return item.destinationFirstName + " " + item.destinationLastName;
            // return Number(value).toLocaleString()
          },
        },
        {
          key: "status",
          label: "وضعیت",
          formatter: (value, key, item) => {
            return this.translateStatus(value);
            // return Number(value).toLocaleString()
          },
          tdClass: (value, key, item) => {
            return this.statusCss(value);
          },
        },
        {
          key: "state",
          label: "مرحله",
          formatter: (value, key, item) => {
            return this.translateState(value);
            // return Number(value).toLocaleString()
          },
          tdClass: (value, key, item) => {
            return this.stateCss(value);
          },
        },
        {
          key: "createdAt",
          label: "تاریخ ثبت",
          formatter(value, key, item) {
            return moment(value).format("jYYYY/jMM/jDD HH:mm:ss");
          },
        },
        {
          key: "submittedAt",
          label: "تاریخ تایید",
          formatter(value, key, item) {
            if (value) return moment(value).format("jYYYY/jMM/jDD HH:mm:ss");
            return "---";
          },
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      params: [
        {
          label: "از تاریخ:",
          field: "date_from",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "date_to",
          type: "date-picker",
        },
        {
          label: "مبلغ (ریال):",
          field: "amount",
          type: "number",
        },
        {
          label: "از تاریخ:",
          field: "submit_date_from",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "submit_date_to",
          type: "date-picker",
        },
        {
          label: "نام صاحب حساب مقصد:",
          field: "nickname",
          type: "text",
        },
        {
          label: "شماره شبا:",
          field: "shaba_number",
          type: "text",
        },
        {
          label: "وضعیت:",
          field: "status",
          type: "select",
          options: [
            {
              text: "همه",
              value: null,
            },
            {
              text: "ترنسفر در حال انجام",
              value: "PENDING",
            },
            {
              text: "تراکنش موفق و دریافت کد رهگیری از بانک",
              value: "SUCCESS",
            },
            {
              text: "نیاز به بررسی دوباره",
              value: "PRE_FAILED",
            },
            {
              text: "خطا در انجام عملیات",
              value: "FAILED",
            },
          ],
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  methods: {
    getList() {
      //   httpHelper
      //     .getData("~transfer-strategy/transfers?pageSize=10")
      //     .then((res) => {
      //       this.list = res.data;
      //     });
    },
    translateStatus(status) {
      switch (status) {
        case "PENDING":
          return "ترنسفر در حال انجام";
        case "SUCCESS":
          return "تراکنش موفق و دریافت کد رهگیری از بانک";
        case "FAILED":
          return "خطا در انجام عملیات";
        case "PRE_FAILED":
          return "نیاز به بررسی دوباره";
        default:
          return "ناشناخته";
      }
    },
    statusCss(status) {
      switch (status) {
        case "PENDING":
          return "text-warning";
        case "SUCCESS":
          return "text-success";
        case "FAILED":
          return "text-danger text-bold";
        default:
          return "ناشناخته";
      }
    },
    translateState(state) {
      switch (state) {
        case "STORE":
          return "دخیر ترنسفر بعد از احراز هویت سمت شپا";
        case "SEND_STRATEGY":
          return "ارسال اطلاعات ترنسفر به سرویس استراتژی ";
        case "RECEIVE_STRATEGY":
          return "دریافت اکشن و پروایدر از سرویس استراتژی";
        case "SEND_TO_PROVIDER":
          return "ارسال درخواست ترنسفر به پروایدر مربوطه";
        case "COMPLETE":
          return "تکمیل فرآیند و دریافت نتیجه نهایی از پروایدر";
        default:
          return "ناشناخته";
      }
    },
    stateCss(state) {
      switch (state) {
        case "STORE":
          return "";
        case "SEND_STRATEGY":
          return "text-primary";
        case "RECEIVE_STRATEGY":
          return "text-primary";
        case "SEND_TO_PROVIDER":
          return "text-warning";
        case "COMPLETE":
          return "text-success";
        default:
          return "text-danger";
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "لیست تسهیم ها" }]);
    this.getList();
  },
};
</script>